/** Leo, 2026-10-03: overdue reads as a compact tag; the exact date goes in a tooltip. */
export const overdueTag = (days: number): string => {
  const d = Math.max(0, Math.floor(days));
  if (d >= 365) return `+${Math.floor(d / 365)}y`;
  if (d >= 183) return "+6mo";
  if (d >= 91) return "+3mo";
  if (d >= 30) return "+1mo";
  return `+${d}d`;
};
